import React, {Component} from 'react';
import {Button} from 'reactstrap';
import {LOCAL_STORAGE_MEMBER_COOKIE_CONSENT} from "../../utils/Constants";

/**
 * Bottom cookie notice: shown until user taps Accept; choice stored in localStorage (same session/device pattern as Just Eat).
 */
export class MemberCookieConsentBanner extends Component {
    constructor(props) {
        super(props);
        this.state = {visible: false};
    }

    componentDidMount() {
        try {
            if (typeof localStorage !== 'undefined' && localStorage.getItem(LOCAL_STORAGE_MEMBER_COOKIE_CONSENT) !== '1') {
                this.setState({visible: true});
            }
        } catch (e) {
            this.setState({visible: true});
        }
    }

    accept = () => {
        try {
            localStorage.setItem(LOCAL_STORAGE_MEMBER_COOKIE_CONSENT, '1');
        } catch (e) { /* ignore */ }
        this.setState({visible: false});
    };

    render() {
        if (!this.state.visible) {
            return null;
        }

        return (
            <div className="memberCookieConsentBanner" role="dialog" aria-label="Cookie notice">
                <div className="memberCookieConsentBannerSideSpacer" aria-hidden="true"/>
                <p className="memberCookieConsentBannerText">
                    We use cookies to give you the best experience. By continuing to use this site you accept our use of cookies. See our footer for Terms &amp; Conditions, Privacy Policy and Cookie Policy.
                </p>
                <div className="memberCookieConsentBannerActions">
                    <Button color="primary" className="memberCookieConsentBannerAccept" onClick={this.accept}>
                        Accept
                    </Button>
                </div>
            </div>
        );
    }
}
